<template>
  <a :href="company.url" target="_blank" class="CompanySliderCard">
    <img :src="company.image" alt="" />
  </a>
</template>

<script>
export default {
  name: 'VoucherSliderCard',
  props: {
    company: {
      type: Object,
      required: true
    },
    index: {
      type: Number,
      required: false
    }
  }
}
</script>

<style lang="scss" scoped>
.CompanySliderCard {
  @apply flex items-center justify-center;
  aspect-ratio: 1 / 1;

  img {
    width: 500px;
    max-width: 75%;
    max-height: 75%;
    object-fit: contain; // we dont want to deform any logo
  }
}
</style>
